import './CenterToast.css'

export default function CenterToast({ open, message }) {
  if (!open || !message) return null

  return (
    <div className="mutelu-center-toast" role="status" aria-live="polite">
      {message}
    </div>
  )
}
